import { jsx as h } from "react/jsx-runtime";
const Z = (l) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...l,
    children: /* @__PURE__ */ h(
      "path",
      {
        fill: "currentColor",
        d: "M41.308 37.427a5.37 5.37 0 0 1-5.365-5.365 5.37 5.37 0 0 1 5.365-5.365 5.37 5.37 0 0 1 5.365 5.365 5.37 5.37 0 0 1-5.365 5.365Zm0-7.734a2.371 2.371 0 0 0-2.368 2.368 2.37 2.37 0 0 0 2.368 2.368 2.37 2.37 0 0 0 2.368-2.368 2.37 2.37 0 0 0-2.368-2.368ZM48.671 32.061c0 .692-.098 1.362-.278 1.998h4.674l-1.071-3.996h-3.604c.18.635.278 1.306.278 1.998h.001ZM33.946 32.061c0-.692.098-1.362.278-1.998h-23.31l1.071 3.996h22.239a7.321 7.321 0 0 1-.278-1.998ZM31.999 51.973a5.37 5.37 0 0 1-5.365-5.365 5.37 5.37 0 0 1 5.365-5.365 5.37 5.37 0 0 1 5.365 5.365 5.37 5.37 0 0 1-5.365 5.365Zm0-7.732a2.371 2.371 0 0 0-2.368 2.368 2.37 2.37 0 0 0 2.368 2.368 2.37 2.37 0 0 0 2.368-2.368 2.37 2.37 0 0 0-2.368-2.368ZM39.362 46.608c0 .692-.098 1.362-.278 1.998h13.983l-1.071-3.996H39.083c.18.635.278 1.306.278 1.998h.001ZM24.638 46.608c0-.692.098-1.362.278-1.998H10.914l1.071 3.996h12.93a7.321 7.321 0 0 1-.278-1.998h.001ZM27.005 22.766a5.37 5.37 0 0 1-5.365-5.365 5.37 5.37 0 0 1 5.365-5.365 5.37 5.37 0 0 1 5.365 5.365 5.37 5.37 0 0 1-5.365 5.365Zm0-7.733a2.37 2.37 0 0 0-2.368 2.368 2.37 2.37 0 0 0 2.368 2.368 2.37 2.37 0 0 0 2.368-2.368 2.37 2.37 0 0 0-2.368-2.368ZM34.368 17.401c0 .692-.098 1.362-.278 1.998h18.977l-1.071-3.996H34.089c.18.635.278 1.306.278 1.998h.001ZM19.643 17.401c0-.692.098-1.362.278-1.998h-9.006l1.071 3.996h7.936a7.321 7.321 0 0 1-.278-1.998h-.001Z"
      }
    )
  }
);
export {
  Z as Filter
};
